<template>
    <div class="menu" :class="{ 'small-menu': smallMenu }">
    
      <MenuItem
        v-for="(item, index) in menuTree"
        :key="index"
        :data="item.children"
        :label="item.label"
        :icon="item.icon"
        :url="item.url"
        :depth="0"
        :smallMenu="smallMenu"
      />
  
      <button type="button" class="boton-menu"  @click="smallMenu = !smallMenu">
         <svg class="fill-black w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>      </button>
    </div>
  </template>
  
  <script>
  import MenuItem from '@/Shared/MenuItem';
  
  export default {
    name: 'recursive-menu',
    data: () => ({
      smallMenu: true,
      menuTree: [
        {
          label: "Facturación",
          icon: "store-front",
          children: [
            {
              label: "Compras",
              children: [
              {
                  label: "Emergentes",
                  url: "orderapplicationsEmergency",
                },
              {
                  label: "Pedido",
                  url: "orderapplications",
                },
                {
                  label: "Solicitud",
                  url: "applicationbuy",
                },{
                  label: "Pagos",
                  url: "applicationbuyPagos",
                }
              ]
            },
            {
              label: "Proveedores",
              url: "contacts",
            },
            {
              label: "Activos",
              url: "machinerys",
            }
          ]
        },
      ]
    }),
    components: {
      MenuItem
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .menu {
    background-color: #D4EFDF;
    position: absolute;
    height: 100vh;
    width: 150px;
    left: 0;
    top: 40px;
    border-right: 1px solid #ececec;
    transition: all .3s ease;
    overflow: auto;
    .boton-menu {
      position: fixed;
      left: 100px;
      font-size: 20px;
      top: 10px;
      user-select: none;
      cursor: pointer;
      transition: all .3s ease;
    }
    &.small-menu {
      overflow: inherit;
      width: 70px;
      padding-top: 4px;
      i {
        left: 20px;
      }
    }
  }
  </style>